<div class="rms-uploader" [class.disabled]="disabled">
  <div class="rms-label-row">
    <span class="rms-label">{{ label }}<span *ngIf="required" class="req">*</span></span>
    <span class="rms-hint" *ngIf="hint">({{hint}})</span>
  </div>


  <div class="dropzone" [class.dragging]="dragging()" (click)="openFileDialog()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave()" (drop)="onDrop($event)">
    <input #fileInput type="file" [attr.accept]="accept || null" [attr.multiple]="multiple ? '' : null" [disabled]="disabled" (change)="onBrowseChange($event)" />


    <div class="dropzone-content">
      <div class="icon">📄</div>
      <div class="text">
        <div class="primary">{{ placeholder }}</div>
        <div class="secondary">Max {{ maxFiles }} file(s), {{ maxSizeMB }}MB each</div>
      </div>
      <button type="button" class="btn" [disabled]="disabled || isAtLimit()">Browse</button>
    </div>
  </div>


  <div class="error" *ngIf="hasError()">{{ errorMsg() }}</div>


  <div class="file-list" *ngIf="count()">
    <div class="file-pill" *ngFor="let f of items()">
      <div class="preview">
        <img *ngIf="f.previewUrl && f.type.startsWith('image/')"  [src]="f.previewUrl" alt="preview">
        <div class="pdf" *ngIf="f.type==='application/pdf'">PDF</div>
<div class="file-kind" *ngIf="f.type.startsWith('video/')" aria-label="Video">▶</div>
<div class="file-kind" *ngIf="f.type!=='application/pdf' && !f.type.startsWith('video/') && !f.previewUrl">FILE</div>
      </div>
      <div class="meta">
        <div class="name" [title]="f.name">{{ f.name }}</div>
        <div class="sub">{{ f.type || 'unknown' }} · {{ (f.size/1024/1024) | number:'1.1-1' }}MB</div>
        <div class="progress" *ngIf="uploader && f.progress != null && f.progress < 100 && !f.error">
          <div class="bar" [style.width.%]="f.progress"></div>
        </div>
        <div class="uploaded" *ngIf="f.progress === 100 && !f.error">Uploaded</div><div class="queued" *ngIf="!uploader && f.progress !== 100 && !f.error">Ready to upload</div>
        <div class="pill-error" *ngIf="f.error">{{ f.error }}</div>
      </div>
      <div class="actions">
        <button type="button" class="icon-btn" *ngIf="uploader" [attr.aria-label]="'Upload '+f.name" (click)="upload(f)" [disabled]="disabled || !f.file || f.progress===100">⬆️</button>
        <button type="button" class="icon-btn danger" [attr.aria-label]="'Remove '+f.name" [disabled]="disabled" (click)="remove(f)">✖</button>
      </div>
    </div>
    <div class="bulk" *ngIf="uploader">
      <button type="button" class="btn" (click)="uploadAll()">Upload all</button>
    </div>
  </div>
</div>
